<template>
  <b-overlay :show="loading" class="animated">
    <modal-trash-basket
      v-if="show_modal"
      :entity_type="entity_type"
      :trash="trash"
      @onUpdate="onUpdate"
    />
    <v-server-table
      :columns="table_config.columns"
      :options="table_config.options"
      :theme="theme"
      :ref="ref"
      id="sample-type-server-table"
      class="w-100"
    >
      <span slot="name" slot-scope="{ row }">
        <a :href="`#/sampletypes/${row.id}`" class="btn-link">{{ row.name }}</a>
      </span>
      <span slot="actions" slot-scope="{ row }">
        <a
          v-show="checkPermission('edit sample type')"
          class="btn btn-warning px-1 py-0 text-white mr-1"
          :href="`#/sampletypes/${row.id}/edit`"
        >
          <i class="fa fa-pencil" />
        </a>
        <template v-if="checkPermission('delete sample type')">
          <a
            v-if="isDeleted(row.id)"
            class="btn btn-success px-1 py-0 text-white mr-1"
            @click="restoreFromTrash(row.id)"
          >
            <i class="fa fa-refresh" />
          </a>
          <a
            v-else
            class="btn btn-danger px-1 py-0 text-white mr-1"
            @click="putToTrash(row)"
          >
            <i class="fa fa-trash" />
          </a>
        </template>
      </span>
    </v-server-table>
  </b-overlay>
</template>

<script>
import Vue from "vue";
import SampleTypeCollection from "@/collections/lab/SampleTypeCollection";
import BaseServerTable from "@/components/shared/BaseServerTable";
import ModalTrashBasket from "@/components/shared/ModalTrashBasket";
import { ServerTable } from "vue-tables-2";
import { mapActions, mapGetters } from "vuex";
import { AccessControlCheck } from "@/auth/AccessControlCheck"

Vue.use(ServerTable);

export default {
  name: "SampleTypeServerTable",
  extends: BaseServerTable,
  components: {
    ModalTrashBasket,
    ServerTable
  },
  props: {
    collection: {
      type: Object,
      default: () => new SampleTypeCollection()
    },
    show_columns: {
      type: Array,
      default: () => ["name", "description", "actions"]
    },
    filterable: {
      type: Array,
      default: () => ["searchable"]
    },
    sortable: {
      type: Array,
      default: () => ["name"]
    }
  },
  data() {
    const actions_access = this.checkPermission("edit sample type")
      || this.checkPermission("delete sample type");

    return {
      entity_type: "sampleType",
      table_config: Object.assign(this.getDefaultTableConfig(actions_access), {
        options: {
          headings: {
            name: "Name",
            description: "Description",
            actions: "Actions"
          }
        }
      })
    };
  },
  computed: {
    ...mapGetters({
      trash: "sampleTypeTrash"
    }),
    show_modal() {
      return this.checkPermission('delete sample type') && this.show_columns.includes("actions")
    }
  },
  methods: {
    ...mapActions(["PUT_TO_TRASH", "RESTORE_FROM_TRASH"]),
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
    putToTrash(value) {
      this.PUT_TO_TRASH({ value, name: this.entity_type });
    },
    restoreFromTrash(id) {
      this.RESTORE_FROM_TRASH({ id, name: this.entity_type });
    },
    isDeleted(id) {
      return this.trash.find(item => item.id === id);
    },
    onUpdate() {
      this.$refs[this.ref].refresh();
    }
  }
};
</script>
